import { Country } from './country.model';

export const CountryIsoNumberToAlpha2CodeMap: ReadonlyMap<Country, string> =
  new Map<Country, string>([
    [Country.AF, 'AF'],
    [Country.AL, 'AL'],
    [Country.DZ, 'DZ'],
    [Country.AS, 'AS'],
    [Country.AD, 'AD'],
    [Country.AO, 'AO'],
    [Country.AI, 'AI'],
    [Country.AQ, 'AQ'],
    [Country.AG, 'AG'],
    [Country.AR, 'AR'],
    [Country.AM, 'AM'],
    [Country.AW, 'AW'],
    [Country.AU, 'AU'],
    [Country.AT, 'AT'],
    [Country.AZ, 'AZ'],
    [Country.BS, 'BS'],
    [Country.BH, 'BH'],
    [Country.BD, 'BD'],
    [Country.BB, 'BB'],
    [Country.BY, 'BY'],
    [Country.BE, 'BE'],
    [Country.BZ, 'BZ'],
    [Country.BJ, 'BJ'],
    [Country.BM, 'BM'],
    [Country.BT, 'BT'],
    [Country.BO, 'BO'],
    [Country.BQ, 'BQ'],
    [Country.BA, 'BA'],
    [Country.BW, 'BW'],
    [Country.BV, 'BV'],
    [Country.BR, 'BR'],
    [Country.IO, 'IO'],
    [Country.BN, 'BN'],
    [Country.BG, 'BG'],
    [Country.BF, 'BF'],
    [Country.BI, 'BI'],
    [Country.CV, 'CV'],
    [Country.KH, 'KH'],
    [Country.CM, 'CM'],
    [Country.CA, 'CA'],
    [Country.KY, 'KY'],
    [Country.CF, 'CF'],
    [Country.TD, 'TD'],
    [Country.CL, 'CL'],
    [Country.CN, 'CN'],
    [Country.CX, 'CX'],
    [Country.CC, 'CC'],
    [Country.CO, 'CO'],
    [Country.KM, 'KM'],
    [Country.CD, 'CD'],
    [Country.CG, 'CG'],
    [Country.CK, 'CK'],
    [Country.CR, 'CR'],
    [Country.HR, 'HR'],
    [Country.CU, 'CU'],
    [Country.CW, 'CW'],
    [Country.CY, 'CY'],
    [Country.CZ, 'CZ'],
    [Country.CI, 'CI'],
    [Country.DK, 'DK'],
    [Country.DJ, 'DJ'],
    [Country.DM, 'DM'],
    [Country.DO, 'DO'],
    [Country.EC, 'EC'],
    [Country.EG, 'EG'],
    [Country.SV, 'SV'],
    [Country.GQ, 'GQ'],
    [Country.ER, 'ER'],
    [Country.EE, 'EE'],
    [Country.SZ, 'SZ'],
    [Country.ET, 'ET'],
    [Country.FK, 'FK'],
    [Country.FO, 'FO'],
    [Country.FJ, 'FJ'],
    [Country.FI, 'FI'],
    [Country.FR, 'FR'],
    [Country.GF, 'GF'],
    [Country.PF, 'PF'],
    [Country.TF, 'TF'],
    [Country.GA, 'GA'],
    [Country.GM, 'GM'],
    [Country.GE, 'GE'],
    [Country.DE, 'DE'],
    [Country.GH, 'GH'],
    [Country.GI, 'GI'],
    [Country.GR, 'GR'],
    [Country.GL, 'GL'],
    [Country.GD, 'GD'],
    [Country.GP, 'GP'],
    [Country.GU, 'GU'],
    [Country.GT, 'GT'],
    [Country.GG, 'GG'],
    [Country.GN, 'GN'],
    [Country.GW, 'GW'],
    [Country.GY, 'GY'],
    [Country.HT, 'HT'],
    [Country.HM, 'HM'],
    [Country.VA, 'VA'],
    [Country.HN, 'HN'],
    [Country.HK, 'HK'],
    [Country.HU, 'HU'],
    [Country.IS, 'IS'],
    [Country.IN, 'IN'],
    [Country.ID, 'ID'],
    [Country.IR, 'IR'],
    [Country.IQ, 'IQ'],
    [Country.IE, 'IE'],
    [Country.IM, 'IM'],
    [Country.IL, 'IL'],
    [Country.IT, 'IT'],
    [Country.JM, 'JM'],
    [Country.JP, 'JP'],
    [Country.JE, 'JE'],
    [Country.JO, 'JO'],
    [Country.KZ, 'KZ'],
    [Country.KE, 'KE'],
    [Country.KI, 'KI'],
    [Country.KP, 'KP'],
    [Country.KR, 'KR'],
    [Country.KW, 'KW'],
    [Country.KG, 'KG'],
    [Country.LA, 'LA'],
    [Country.LV, 'LV'],
    [Country.LB, 'LB'],
    [Country.LS, 'LS'],
    [Country.LR, 'LR'],
    [Country.LY, 'LY'],
    [Country.LI, 'LI'],
    [Country.LT, 'LT'],
    [Country.LU, 'LU'],
    [Country.MO, 'MO'],
    [Country.MG, 'MG'],
    [Country.MW, 'MW'],
    [Country.MY, 'MY'],
    [Country.MV, 'MV'],
    [Country.ML, 'ML'],
    [Country.MT, 'MT'],
    [Country.MH, 'MH'],
    [Country.MQ, 'MQ'],
    [Country.MR, 'MR'],
    [Country.MU, 'MU'],
    [Country.YT, 'YT'],
    [Country.MX, 'MX'],
    [Country.FM, 'FM'],
    [Country.MD, 'MD'],
    [Country.MC, 'MC'],
    [Country.MN, 'MN'],
    [Country.ME, 'ME'],
    [Country.MS, 'MS'],
    [Country.MA, 'MA'],
    [Country.MZ, 'MZ'],
    [Country.MM, 'MM'],
    [Country.NA, 'NA'],
    [Country.NR, 'NR'],
    [Country.NP, 'NP'],
    [Country.NL, 'NL'],
    [Country.NC, 'NC'],
    [Country.NZ, 'NZ'],
    [Country.NI, 'NI'],
    [Country.NE, 'NE'],
    [Country.NG, 'NG'],
    [Country.NU, 'NU'],
    [Country.NF, 'NF'],
    [Country.MP, 'MP'],
    [Country.NO, 'NO'],
    [Country.OM, 'OM'],
    [Country.PK, 'PK'],
    [Country.PW, 'PW'],
    [Country.PS, 'PS'],
    [Country.PA, 'PA'],
    [Country.PG, 'PG'],
    [Country.PY, 'PY'],
    [Country.PE, 'PE'],
    [Country.PH, 'PH'],
    [Country.PN, 'PN'],
    [Country.PL, 'PL'],
    [Country.PT, 'PT'],
    [Country.PR, 'PR'],
    [Country.QA, 'QA'],
    [Country.MK, 'MK'],
    [Country.RO, 'RO'],
    [Country.RU, 'RU'],
    [Country.RW, 'RW'],
    [Country.RE, 'RE'],
    [Country.BL, 'BL'],
    [Country.SH, 'SH'],
    [Country.KN, 'KN'],
    [Country.LC, 'LC'],
    [Country.MF, 'MF'],
    [Country.PM, 'PM'],
    [Country.VC, 'VC'],
    [Country.WS, 'WS'],
    [Country.SM, 'SM'],
    [Country.ST, 'ST'],
    [Country.SA, 'SA'],
    [Country.SN, 'SN'],
    [Country.RS, 'RS'],
    [Country.SC, 'SC'],
    [Country.SL, 'SL'],
    [Country.SG, 'SG'],
    [Country.SX, 'SX'],
    [Country.SK, 'SK'],
    [Country.SI, 'SI'],
    [Country.SB, 'SB'],
    [Country.SO, 'SO'],
    [Country.ZA, 'ZA'],
    [Country.GS, 'GS'],
    [Country.SS, 'SS'],
    [Country.ES, 'ES'],
    [Country.LK, 'LK'],
    [Country.SD, 'SD'],
    [Country.SR, 'SR'],
    [Country.SJ, 'SJ'],
    [Country.SE, 'SE'],
    [Country.CH, 'CH'],
    [Country.SY, 'SY'],
    [Country.TW, 'TW'],
    [Country.TJ, 'TJ'],
    [Country.TZ, 'TZ'],
    [Country.TH, 'TH'],
    [Country.TL, 'TL'],
    [Country.TG, 'TG'],
    [Country.TK, 'TK'],
    [Country.TO, 'TO'],
    [Country.TT, 'TT'],
    [Country.TN, 'TN'],
    [Country.TR, 'TR'],
    [Country.TM, 'TM'],
    [Country.TC, 'TC'],
    [Country.TV, 'TV'],
    [Country.UG, 'UG'],
    [Country.UA, 'UA'],
    [Country.AE, 'AE'],
    [Country.GB, 'GB'],
    [Country.UM, 'UM'],
    [Country.US, 'US'],
    [Country.UY, 'UY'],
    [Country.UZ, 'UZ'],
    [Country.VU, 'VU'],
    [Country.VE, 'VE'],
    [Country.VN, 'VN'],
    [Country.VG, 'VG'],
    [Country.VI, 'VI'],
    [Country.WF, 'WF'],
    [Country.EH, 'EH'],
    [Country.YE, 'YE'],
    [Country.ZM, 'ZM'],
    [Country.ZW, 'ZW'],
    [Country.AX, 'AX'],
  ]);

export const CountryIsoNumberToAlpha3CodeMap: ReadonlyMap<Country, string> =
  new Map<Country, string>([
    [Country.AF, 'AFG'],
    [Country.AL, 'ALB'],
    [Country.DZ, 'DZA'],
    [Country.AS, 'ASM'],
    [Country.AD, 'AND'],
    [Country.AO, 'AGO'],
    [Country.AI, 'AIA'],
    [Country.AQ, 'ATA'],
    [Country.AG, 'ATG'],
    [Country.AR, 'ARG'],
    [Country.AM, 'ARM'],
    [Country.AW, 'ABW'],
    [Country.AU, 'AUS'],
    [Country.AT, 'AUT'],
    [Country.AZ, 'AZE'],
    [Country.BS, 'BHS'],
    [Country.BH, 'BHR'],
    [Country.BD, 'BGD'],
    [Country.BB, 'BRB'],
    [Country.BY, 'BLR'],
    [Country.BE, 'BEL'],
    [Country.BZ, 'BLZ'],
    [Country.BJ, 'BEN'],
    [Country.BM, 'BMU'],
    [Country.BT, 'BTN'],
    [Country.BO, 'BOL'],
    [Country.BQ, 'BES'],
    [Country.BA, 'BIH'],
    [Country.BW, 'BWA'],
    [Country.BV, 'BVT'],
    [Country.BR, 'BRA'],
    [Country.IO, 'IOT'],
    [Country.BN, 'BRN'],
    [Country.BG, 'BGR'],
    [Country.BF, 'BFA'],
    [Country.BI, 'BDI'],
    [Country.CV, 'CPV'],
    [Country.KH, 'KHM'],
    [Country.CM, 'CMR'],
    [Country.CA, 'CAN'],
    [Country.KY, 'CYM'],
    [Country.CF, 'CAF'],
    [Country.TD, 'TCD'],
    [Country.CL, 'CHL'],
    [Country.CN, 'CHN'],
    [Country.CX, 'CXR'],
    [Country.CC, 'CCK'],
    [Country.CO, 'COL'],
    [Country.KM, 'COM'],
    [Country.CD, 'COD'],
    [Country.CG, 'COG'],
    [Country.CK, 'COK'],
    [Country.CR, 'CRI'],
    [Country.HR, 'HRV'],
    [Country.CU, 'CUB'],
    [Country.CW, 'CUW'],
    [Country.CY, 'CYP'],
    [Country.CZ, 'CZE'],
    [Country.CI, 'CIV'],
    [Country.DK, 'DNK'],
    [Country.DJ, 'DJI'],
    [Country.DM, 'DMA'],
    [Country.DO, 'DOM'],
    [Country.EC, 'ECU'],
    [Country.EG, 'EGY'],
    [Country.SV, 'SLV'],
    [Country.GQ, 'GNQ'],
    [Country.ER, 'ERI'],
    [Country.EE, 'EST'],
    [Country.SZ, 'SWZ'],
    [Country.ET, 'ETH'],
    [Country.FK, 'FLK'],
    [Country.FO, 'FRO'],
    [Country.FJ, 'FJI'],
    [Country.FI, 'FIN'],
    [Country.FR, 'FRA'],
    [Country.GF, 'GUF'],
    [Country.PF, 'PYF'],
    [Country.TF, 'ATF'],
    [Country.GA, 'GAB'],
    [Country.GM, 'GMB'],
    [Country.GE, 'GEO'],
    [Country.DE, 'DEU'],
    [Country.GH, 'GHA'],
    [Country.GI, 'GIB'],
    [Country.GR, 'GRC'],
    [Country.GL, 'GRL'],
    [Country.GD, 'GRD'],
    [Country.GP, 'GLP'],
    [Country.GU, 'GUM'],
    [Country.GT, 'GTM'],
    [Country.GG, 'GGY'],
    [Country.GN, 'GIN'],
    [Country.GW, 'GNB'],
    [Country.GY, 'GUY'],
    [Country.HT, 'HTI'],
    [Country.HM, 'HMD'],
    [Country.VA, 'VAT'],
    [Country.HN, 'HND'],
    [Country.HK, 'HKG'],
    [Country.HU, 'HUN'],
    [Country.IS, 'ISL'],
    [Country.IN, 'IND'],
    [Country.ID, 'IDN'],
    [Country.IR, 'IRN'],
    [Country.IQ, 'IRQ'],
    [Country.IE, 'IRL'],
    [Country.IM, 'IMN'],
    [Country.IL, 'ISR'],
    [Country.IT, 'ITA'],
    [Country.JM, 'JAM'],
    [Country.JP, 'JPN'],
    [Country.JE, 'JEY'],
    [Country.JO, 'JOR'],
    [Country.KZ, 'KAZ'],
    [Country.KE, 'KEN'],
    [Country.KI, 'KIR'],
    [Country.KP, 'PRK'],
    [Country.KR, 'KOR'],
    [Country.KW, 'KWT'],
    [Country.KG, 'KGZ'],
    [Country.LA, 'LAO'],
    [Country.LV, 'LVA'],
    [Country.LB, 'LBN'],
    [Country.LS, 'LSO'],
    [Country.LR, 'LBR'],
    [Country.LY, 'LBY'],
    [Country.LI, 'LIE'],
    [Country.LT, 'LTU'],
    [Country.LU, 'LUX'],
    [Country.MO, 'MAC'],
    [Country.MG, 'MDG'],
    [Country.MW, 'MWI'],
    [Country.MY, 'MYS'],
    [Country.MV, 'MDV'],
    [Country.ML, 'MLI'],
    [Country.MT, 'MLT'],
    [Country.MH, 'MHL'],
    [Country.MQ, 'MTQ'],
    [Country.MR, 'MRT'],
    [Country.MU, 'MUS'],
    [Country.YT, 'MYT'],
    [Country.MX, 'MEX'],
    [Country.FM, 'FSM'],
    [Country.MD, 'MDA'],
    [Country.MC, 'MCO'],
    [Country.MN, 'MNG'],
    [Country.ME, 'MNE'],
    [Country.MS, 'MSR'],
    [Country.MA, 'MAR'],
    [Country.MZ, 'MOZ'],
    [Country.MM, 'MMR'],
    [Country.NA, 'NAM'],
    [Country.NR, 'NRU'],
    [Country.NP, 'NPL'],
    [Country.NL, 'NLD'],
    [Country.NC, 'NCL'],
    [Country.NZ, 'NZL'],
    [Country.NI, 'NIC'],
    [Country.NE, 'NER'],
    [Country.NG, 'NGA'],
    [Country.NU, 'NIU'],
    [Country.NF, 'NFK'],
    [Country.MP, 'MNP'],
    [Country.NO, 'NOR'],
    [Country.OM, 'OMN'],
    [Country.PK, 'PAK'],
    [Country.PW, 'PLW'],
    [Country.PS, 'PSE'],
    [Country.PA, 'PAN'],
    [Country.PG, 'PNG'],
    [Country.PY, 'PRY'],
    [Country.PE, 'PER'],
    [Country.PH, 'PHL'],
    [Country.PN, 'PCN'],
    [Country.PL, 'POL'],
    [Country.PT, 'PRT'],
    [Country.PR, 'PRI'],
    [Country.QA, 'QAT'],
    [Country.MK, 'MKD'],
    [Country.RO, 'ROU'],
    [Country.RU, 'RUS'],
    [Country.RW, 'RWA'],
    [Country.RE, 'REU'],
    [Country.BL, 'BLM'],
    [Country.SH, 'SHN'],
    [Country.KN, 'KNA'],
    [Country.LC, 'LCA'],
    [Country.MF, 'MAF'],
    [Country.PM, 'SPM'],
    [Country.VC, 'VCT'],
    [Country.WS, 'WSM'],
    [Country.SM, 'SMR'],
    [Country.ST, 'STP'],
    [Country.SA, 'SAU'],
    [Country.SN, 'SEN'],
    [Country.RS, 'SRB'],
    [Country.SC, 'SYC'],
    [Country.SL, 'SLE'],
    [Country.SG, 'SGP'],
    [Country.SX, 'SXM'],
    [Country.SK, 'SVK'],
    [Country.SI, 'SVN'],
    [Country.SB, 'SLB'],
    [Country.SO, 'SOM'],
    [Country.ZA, 'ZAF'],
    [Country.GS, 'SGS'],
    [Country.SS, 'SSD'],
    [Country.ES, 'ESP'],
    [Country.LK, 'LKA'],
    [Country.SD, 'SDN'],
    [Country.SR, 'SUR'],
    [Country.SJ, 'SJM'],
    [Country.SE, 'SWE'],
    [Country.CH, 'CHE'],
    [Country.SY, 'SYR'],
    [Country.TW, 'TWN'],
    [Country.TJ, 'TJK'],
    [Country.TZ, 'TZA'],
    [Country.TH, 'THA'],
    [Country.TL, 'TLS'],
    [Country.TG, 'TGO'],
    [Country.TK, 'TKL'],
    [Country.TO, 'TON'],
    [Country.TT, 'TTO'],
    [Country.TN, 'TUN'],
    [Country.TR, 'TUR'],
    [Country.TM, 'TKM'],
    [Country.TC, 'TCA'],
    [Country.TV, 'TUV'],
    [Country.UG, 'UGA'],
    [Country.UA, 'UKR'],
    [Country.AE, 'ARE'],
    [Country.GB, 'GBR'],
    [Country.UM, 'UMI'],
    [Country.US, 'USA'],
    [Country.UY, 'URY'],
    [Country.UZ, 'UZB'],
    [Country.VU, 'VUT'],
    [Country.VE, 'VEN'],
    [Country.VN, 'VNM'],
    [Country.VG, 'VGB'],
    [Country.VI, 'VIR'],
    [Country.WF, 'WLF'],
    [Country.EH, 'ESH'],
    [Country.YE, 'YEM'],
    [Country.ZM, 'ZMB'],
    [Country.ZW, 'ZWE'],
    [Country.AX, 'ALA'],
  ]);
